import Spinner from '@/components/Spinner/Spinner.tsx';

function Loading() {
  return (
    <div
      className="bg-background relative flex flex-col h-screen justify-center items-center"
    >
      <div className="opacity-0 animate-fade-in [animation-delay:1000ms] text-default-600">
        <Spinner size={50} />
      </div>
    </div>
  );
}

export default Loading;
